import React, { useState } from 'react';
import { Upload, Download, X, Wrench } from 'lucide-react';
import { SUPABASE_URL, SUPABASE_ANON_KEY } from '../../config/env.js';

const MechanicCSVUpload = () => {
  const [selectedFile, setSelectedFile] = useState(null);
  const [isUploading, setIsUploading] = useState(false);
  const [uploadProgress, setUploadProgress] = useState({ total: 0, processed: 0, success: 0, failed: 0 });
  const [errorDetails, setErrorDetails] = useState([]);
  const [showErrorModal, setShowErrorModal] = useState(false);

  const downloadTemplate = () => {
    const template = `code,mechanic_name,number,alternate_number1,alternate_number2,service_tag,service_tag2,service_tag3,timing,active,area1,pincode1,state1,area2,pincode2,state2
MECH001,John Doe,9876543210,9876543211,9876543212,Engine Specialist,Oil Change,Filter Replacement,9:00 AM - 6:00 PM,true,Connaught Place,110001,Delhi,Karol Bagh,110005,Delhi`;
    
    const blob = new Blob([template], { type: 'text/csv' });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = 'mechanics_template.csv';
    a.click();
    window.URL.revokeObjectURL(url);
  };

  const handleFileSelect = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    setSelectedFile(file);
    alert('File selected. Upload functionality will be implemented.');
  };

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-3xl font-bold text-gray-900">Mechanic CSV Upload</h1>
        <p className="text-gray-600 mt-1">Upload mechanics with service areas via CSV file</p>
      </div>

      <div className="bg-white rounded-xl p-6 shadow-sm border border-gray-200">
        <div className="flex items-center justify-between mb-4">
          <div>
            <h3 className="font-semibold text-gray-900 mb-1">CSV Template</h3>
            <p className="text-sm text-gray-600">Download the template to see the required format</p>
          </div>
          <button
            onClick={downloadTemplate}
            className="flex items-center space-x-2 px-4 py-2 bg-indigo-600 text-white rounded-lg hover:bg-indigo-700"
          >
            <Download size={18} />
            <span>Download Template</span>
          </button>
        </div>

        <div className="border-2 border-dashed border-gray-300 rounded-lg p-8 text-center">
          <input
            type="file"
            accept=".csv"
            onChange={handleFileSelect}
            disabled={isUploading}
            className="hidden"
            id="mechanic-csv-upload"
          />
          <label
            htmlFor="mechanic-csv-upload"
            className={`cursor-pointer flex flex-col items-center ${isUploading ? 'opacity-50 cursor-not-allowed' : ''}`}
          >
            <Upload size={48} className="text-gray-400 mb-4" />
            <p className="text-gray-600 mb-2">
              {selectedFile ? selectedFile.name : 'Click to select CSV file'}
            </p>
            <p className="text-sm text-gray-500">CSV files only</p>
          </label>
        </div>
      </div>
    </div>
  );
};

export default MechanicCSVUpload;

